import { render, staticRenderFns } from "./event-details.vue?vue&type=template&id=e4bcdc08&scoped=true"
import script from "./event-details.vue?vue&type=script&lang=js"
export * from "./event-details.vue?vue&type=script&lang=js"
import style0 from "./event-details.vue?vue&type=style&index=0&id=e4bcdc08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bcdc08",
  null
  
)

export default component.exports